<div class="modal-header">
  <h5 class="modal-title">Carpeta de destino</h5>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p class="small mb-3">
    Destino seleccionado:
    <strong class="text-primary">{{ selectedPath || 'Contratos' }}</strong>
  </p>

  <div class="lexgo-folder-picker__nav mb-2">
    <span class="small text-muted mr-2">{{ currentPath }}</span>
    @if (parentPath) {
      <button type="button" class="btn btn-link btn-sm p-0" (click)="goUp()">Subir</button>
    }
  </div>

  @if (loading) {
    <div class="text-muted py-3">Cargando carpetas…</div>
  } @else {
    <div class="lexgo-folder-picker__list mb-3">
      <button
        type="button"
        class="lexgo-folder-picker__item"
        [class.lexgo-folder-picker__item--active]="selectedPath === currentPath"
        (click)="selectFolder(currentPath)"
      >
        <i class="fas fa-folder-open text-warning mr-2"></i>
        Usar esta carpeta ({{ currentPath }})
      </button>
      @for (folder of folders; track folder.path) {
        <div class="lexgo-folder-picker__row">
          <button
            type="button"
            class="lexgo-folder-picker__item"
            [class.lexgo-folder-picker__item--active]="selectedPath === folder.path"
            (click)="selectFolder(folder.path)"
          >
            <i class="fas fa-folder text-warning mr-2"></i>
            {{ folder.name }}
          </button>
          <button type="button" class="btn btn-link btn-sm" (click)="openFolder(folder.path)">
            Abrir
          </button>
        </div>
      }
      @if (!folders.length) {
        <div class="text-muted small px-2 py-2">No hay subcarpetas aquí.</div>
      }
    </div>
  }

  <div class="input-group input-group-sm">
    <input
      type="text"
      class="form-control"
      placeholder="Nueva carpeta aquí"
      [(ngModel)]="newFolderName"
      (keyup.enter)="createFolder()"
    />
    <div class="input-group-append">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="createFolder()"
        [disabled]="!(newFolderName || '').trim()"
      >
        Crear
      </button>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">Seleccionar</button>
</div>
